import { render, staticRenderFns } from "./2021Main.vue?vue&type=template&id=283b666e&scoped=true&"
import script from "./2021Main.vue?vue&type=script&lang=js&"
export * from "./2021Main.vue?vue&type=script&lang=js&"
import style0 from "./2021Main.vue?vue&type=style&index=0&id=283b666e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283b666e",
  null
  
)

export default component.exports
import {QHeader,QToolbar,QBtn,QTooltip,QToolbarTitle,QCard,QTabs,QTab,QSeparator,QTabPanels,QTabPanel} from 'quasar'
component.options.components = Object.assign({QHeader,QToolbar,QBtn,QTooltip,QToolbarTitle,QCard,QTabs,QTab,QSeparator,QTabPanels,QTabPanel}, component.options.components || {})
